/** API route map: URLS.Controller.EmployeeTask */
export const EmployeeTask = {
      Name: 'EmployeeTask/',
      GetAllTask: 'employee-task',
      AddTask: 'add',
      UpdateTask: 'update',
      DeleteTask: 'delete',
      PatchTaskStatus: 'patch-task-status',
      GetAllEmployeeTask: 'employee-portal-task',
      SubmitTask: 'submit-task',
      GetEmployeeUser: 'get-user',
};
